/**
 * Created by slava on 3/3/20
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    BLUE: new cc.Color(0, 0, 160, 255),
    YELLOW_TEXT: new cc.Color(255, 208, 0, 255),
    AMOUNT_STROKE_COLOR: new cc.Color(61, 10, 0, 255),
    TITLE_COLOR_YELLOW: new cc.Color(134, 56, 10, 255),
    TITLE_SHADOW: new cc.Color(255, 251, 126, 255)
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    EXTRA_HAND_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.BLUE,
        size: 3
    },
    BUSTER_AMOUNT_STROKE: {
        color: cleverapps.styles.COLORS.AMOUNT_STROKE_COLOR,
        size: 3
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EXTRA_HAND_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.EXTRA_HAND_TEXT_STROKE
    },
    BOOSTER_BEFORE_AMOUNT_TEXT: {
        name: "default",
        size: 44,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.overrideStyles(cleverapps.styles.RewardGoldView, {
    width: 165,
    height: 86,

    icon: {
        x: 30,
        y: 57
    },

    position: [
        {
            x: { align: "left", dx: 10 },
            y: { align: "top", dy: -130 }
        },
        {
            x: { align: "left", dx: 33 },
            y: { align: "top", dy: -130 }
        },
        {
            x: { align: "left", dx: 33 },
            y: { align: "top", dy: -130 }
        }
    ]
});

if (cleverapps.styles.LightningRushMarksView) {
    cleverapps.overrideStyles(cleverapps.styles.LightningRushMarksView, {
        width: 165,
        height: 86,

        icon: {
            x: { align: "left", dx: -10 }
        },

        position: [
            {
                x: { align: "left", dx: 10 },
                y: { align: "top", dy: -230 }
            },
            {
                x: { align: "left", dx: 236 },
                y: { align: "top", dy: -130 }
            },
            {
                x: { align: "left", dx: 250 },
                y: { align: "top", dy: -130 }
            }
        ]
    });
}

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    YELLOW_BUTTON_TITLE_SHADOW: new cc.Color(34, 54, 0, 255),
    COLOR_RED: new cc.Color(255, 70, 40, 255),
    EXPIRED_TASK_FONT_COLOR: new cc.Color(0, 0, 0, 255),
    BOOSTER_BEFORE_COINS_PRICE_COLOR: new cc.Color(64, 29, 0, 255),
    HINT_ALARM_COLOR: new cc.Color(150, 150, 150, 255),
    DARK_COLOR: new cc.Color(77, 67, 62)
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    IMAGE_FONT_STROKE_THIN: {
        color: cleverapps.styles.COLORS.BLACK_STROKE,
        size: 1
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EPISODE_TITLE_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.TITLE_COLOR_YELLOW,
        shadow: cleverapps.styles.DECORATORS.TITLE_TEXT_SHADOW
    },
    REWARDS_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },
    LEVEL_CURRENT_TITLE_TEXT: {
        name: "default"
    },

    LOADING_ANIMATION_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.WINDOW_WHITE_TEXT_STROKE
    }
});

cleverapps.overrideStyles(cleverapps.styles.VictoryWindow, {
    soundDelay: 0.4
});

cleverapps.overrideStyles(cleverapps.styles.ProgressView, {
    arrows: {
        y: { align: "center", dy: 6 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.GameScene, {
    debugLevelNo: {
        x: { align: "right", dx: -160 },
        y: { align: "bottom", dy: 100 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.RestoreProgressButton, {
    position: [
        {
            x: { align: "left", dx: 20 },
            y: { align: "bottom", dy: 20 }
        },
        {
            x: { align: "right", dx: -20 },
            y: { align: "bottom", dy: 20 }
        },
        {
            x: { align: "right", dx: -20 },
            y: { align: "top", dy: -110 }
        }
    ]
});

cleverapps.overrideStyles(cleverapps.styles.LoseWindow, {
    livesLeftText: {
        width: 500
    }
});

cleverapps.overrideStyles(cleverapps.styles.BackgroundsWindow, {
    name: false
});
